import { useEffect, useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_ALL_MEDIA } from "../../routes";
import { debug } from "../../utils/helpers";
import { DEFAULT_ALL_MEDIA_VIEW_PAYLOAD } from "../../constants";

export default function useGetAllMedia(auto = false) {
  const [allMedia, setAllMedia] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getAllMedia = (payload = {}, showLoader = true) => {
    setIsLoading(showLoader);
    return Api.post(API_ROUTE_ALL_MEDIA, {
      ...DEFAULT_ALL_MEDIA_VIEW_PAYLOAD,
      ...payload,
    })
      .then((response) => {
        setAllMedia(response.data);
      })
      .catch((error) => {
        debug.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!auto) {
      return;
    }
    getAllMedia();
  }, [auto]);

  return {
    allMedia,
    getAllMedia,
    isLoading,
    setAllMedia,
  };
}
